'use strict';

const $ = window.jQuery;

export default function () {
    if ($('.jobs-partners').length <= 0) {
        return;
    }

    const carousel = new Swiper('#partnersList', {
        loop: true,
        pagination: false,
        slidesPerView: 5,
        navigation: {
            prevEl: '.carousel-nav--prev',
            nextEl: '.carousel-nav--next'
        }
    });
}
